export enum TemperatureSource {
    Oral = 1,
    Rectal = 2,
    Axillary = 3,
    Tympanic = 4,
}